import type { DogBreederLastConnectedTypeEnum } from '@gql/graphql';
import type { HTMLAttributes } from 'react';

export interface ConnectionTagData {
  type: DogBreederLastConnectedTypeEnum;
}

export interface ConnectionTagProps extends ConnectionTagData, HTMLAttributes<HTMLDivElement> {}
